
import { defineComponent, } from 'vue'
import type { PropType } from 'vue'

type Image = {
	src: string,
	alt: string
}

type Person = {
	wpId: number,
	url: string,
	image: Image,
	name: string,
	active: boolean,
	unreadMessage: number
}

export default defineComponent({
	name: 'ChatPeopleBar',
	props: {
		peopleList: {
			type: Array as PropType<Person[]>,
			required: true
		}
	},
	components: {
		// HelloWorld
	},
	data(){
		return {};
	},
	methods: {
		changeChat(id: number){
			this.peopleList.map((people: Person): boolean => (
				people.active = people.wpId === id
			))
			this.$emit('changeChat')
		}
	}
})
